import { render, staticRenderFns } from "./JobListItemPlaceholder.vue?vue&type=template&id=ebcbb2b2&scoped=true"
import script from "./JobListItemPlaceholder.vue?vue&type=script&lang=js"
export * from "./JobListItemPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./JobListItemPlaceholder.vue?vue&type=style&index=0&id=ebcbb2b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebcbb2b2",
  null
  
)

export default component.exports